/**
 * A stored custom-field date is a calendar day at UTC midnight (`YYYY-MM-DD`
 * on write, a timestamp on read). Read its UTC day, never the instant, so
 * every time zone shows the same day.
 */
export function parseStoredDate(raw: Date | string): Date {
  const instant = typeof raw === 'string' ? new Date(raw) : raw;
  return new Date(
    instant.getUTCFullYear(),
    instant.getUTCMonth(),
    instant.getUTCDate()
  );
}

/** The local calendar day of `date` as `YYYY-MM-DD`. */
export function formatStoredDate(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}
